import {
  USOBMODELS_LOADING,
  SUBMIT_USOBMODELS_ACTION_DISPATCHER,
  SUBMIT_USOBMODELS_ACTION_REQUESTED,
  SUBMIT_USOBMODELS_ERROR_DISPATCHER,
} from "./Action";

const initialState = {
  successData: { usobModelList: [], apiData: {} },
  failureData: {},
  loading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_USOBMODELS_ACTION_REQUESTED:
      return { ...state, loading: true };
    case SUBMIT_USOBMODELS_ACTION_DISPATCHER:
      const usobModelList = []
      action.payload.data.success?.modelnos?.forEach((e) => {
        usobModelList.push({ value: e.model_no });
      });
      return {
        ...state,
        successData: {
          usobModelList: usobModelList.filter((v, i, a) => a.indexOf(v) === i),
          apiData: action.payload.data
        },
        loading: false,
      };
    case SUBMIT_USOBMODELS_ERROR_DISPATCHER:
      return {
        ...state,
        failureData: action.payload,
        loading: false,
      };
    case USOBMODELS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
